<template>
  <div id="page-category-create">
    {{ /* Heading page */ }}
    <div class="header-pages-block d-md-flex justify-content-between mb-md-4">
      <h5 class="">{{ $t('pages.category.createCategory') }}</h5>
      <div>
        <router-link
            class="btn btn-outline-primary mt-2 mt-md-0"
            :to="{ name: 'category-index' }"
        >
          {{ $t('common.back') }}
        </router-link>
      </div>
    </div>

    {{ /* Form component */ }}
    <FormCrudCategory
        :category="category"
        :list-provide-number-per-rolls="[]"
        :list-mandrels="[]"
        :list-orientations="[]"
        :list-papers="[]"
        :actionForm="'create'"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      category: {}
    }
  },
  components : {
    FormCrudCategory: () => import('@/components/pages/category/FormCrudCategory')
  }
}
</script>

<style scoped>

</style>
